var React = require('react');

function Sms (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M16 9.964a1 1 0 0 1-1 1h-2.216l.056 1.921a.5.5 0 0 1-.798.416l-3.145-2.337H1a1 1 0 0 1-1-1V1a1 1 0 0 1 1-1h14a1 1 0 0 1 1 1v8.964zM3.716 6.542a1.271 1.271 0 1 0 0-2.542 1.271 1.271 0 0 0 0 2.542zm5.15-.34a1.271 1.271 0 1 0-1.732-1.861 1.271 1.271 0 0 0 1.732 1.861zm3.418.34a1.271 1.271 0 1 0 0-2.542 1.271 1.271 0 0 0 0 2.542z","fill":"#424242","fillRule":"evenodd"}));
}

Sms.defaultProps = {"width":"16","height":"14","viewBox":"0 0 16 14"};

module.exports = Sms;

Sms.default = Sms;
